// extracted by mini-css-extract-plugin
module.exports = {"parent":"ob_eX8s2r","searchIcon":"ob_vXeRN6"};